import { TypeIdSchema } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { EventTypeSchema } from '../event/event.schema';

export const InvalidateWebhookCacheRequestSchema = Type.Object({
  account_ids: Type.Array(TypeIdSchema('account'), {
    minItems: 1,
    uniqueItems: true,
  }),
  event_types: Type.Array(EventTypeSchema, { minItems: 1, uniqueItems: true }),
});

export type InvalidateWebhookCacheRequest = Static<typeof InvalidateWebhookCacheRequestSchema>;
